"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _helpers = require("./helpers");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var RuleValue = function RuleValue(_ref) {
  var errors = _ref.errors,
    id = _ref.id,
    onChange = _ref.onChange,
    type = _ref.type,
    value = _ref.value,
    lookUpValues = _ref.lookUpValues,
    allowsMultipleSelect = _ref.allowsMultipleSelect,
    disabled = _ref.disabled,
    labels = _ref.labels,
    operatorValue = _ref.operatorValue,
    searchableAction = _ref.searchableAction,
    variableOperands = _ref.variableOperands,
    valueRenderer = _ref.valueRenderer;
  var _computeInputType = (0, _helpers.computeInputType)({
      variableOperands: variableOperands,
      errors: errors,
      id: id,
      onChange: onChange,
      type: type,
      value: value,
      lookUpValues: lookUpValues,
      allowsMultipleSelect: allowsMultipleSelect,
      labels: labels,
      operatorValue: operatorValue,
      valueRenderer: valueRenderer
    }),
    ValueInput = _computeInputType.ValueInput,
    inputProps = _computeInputType.inputProps,
    handleOnChange = _computeInputType.handleOnChange;
  return /*#__PURE__*/_react["default"].createElement(ValueInput, _extends({
    errors: errors,
    disabled: disabled,
    id: id,
    onChange: handleOnChange,
    placeholder: labels.ELIGIBILITY_VALUE_PLACEHOLDER || 'Value',
    value: value,
    labels: labels,
    searchableAction: searchableAction
  }, inputProps, {
    className: "simple-rule-value ".concat(inputProps.className)
  }));
};
RuleValue.propTypes = {
  operatorValue: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].shape({})]),
  /** If `true`, the input will indicate an error. */
  errors: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].arrayOf(_propTypes["default"].string)]),
  /** If `true`, the input will indicate an error. */
  disabled: _propTypes["default"].bool,
  /** Html id. */
  id: _propTypes["default"].string.isRequired,
  /** The list of posible values. */
  lookUpValues: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    value: _propTypes["default"].string,
    label: _propTypes["default"].string
  })),
  /** Flag to indicate weather the operator allows multiple values */
  allowsMultipleSelect: _propTypes["default"].bool,
  /** Callback for when changing the operator. */
  onChange: _propTypes["default"].func.isRequired,
  /** The type of the value in the rule */
  type: _propTypes["default"].oneOf(['string', 'integer', 'double', 'decimal', 'datetime', 'boolean']).isRequired,
  /** The value of the simple rule  */
  value: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].string), _propTypes["default"].string, _propTypes["default"].instanceOf(Date)]),
  /** CMS labels */
  labels: _propTypes["default"].shape({
    ELIGIBILITY_VALUE_PLACEHOLDER: _propTypes["default"].string
  }),
  searchableAction: _propTypes["default"].func.isRequired,
  variableOperands: _propTypes["default"].arrayOf(_propTypes["default"].shape({})),
  valueRenderer: _propTypes["default"].func
};
RuleValue.defaultProps = {
  variableOperands: [],
  operatorValue: '',
  allowsMultipleSelect: false,
  errors: undefined,
  disabled: false,
  lookUpValues: undefined,
  value: undefined,
  labels: {},
  valueRenderer: undefined
};
var _default = exports["default"] = RuleValue;